import styled from "styled-components";

export const Wrapper = styled.div`
  .marketplace-expiry-subtext {
    font-size: 12px;
    color: var(--app-text-muted);
  }

  .marketplace-mobile-credential-card {
    background: var(--app-surface);
    border-color: var(--app-border) !important;
  }

  .marketplace-mobile-value {
    color: var(--app-text);
  }

  .marketplace-empty-state {
    min-height: 250px;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, #f45b68 6%, var(--app-surface)) 0%,
      var(--app-surface) 100%
    );
    border-radius: 24px;
    border: 1px solid var(--app-border);
  }

  .marketplace-empty-icon-wrap {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(244, 91, 104, 0.15), rgba(244, 91, 104, 0.05));
    border: 1px solid rgba(244, 91, 104, 0.2);
    box-shadow: 0 10px 35px rgba(244, 91, 104, 0.15);
  }

  .marketplace-empty-icon-ring {
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    border: 2px dashed rgba(255, 153, 0, 0.25);
    animation: marketplaceSpinSlow 14s linear infinite;
  }

  .marketplace-empty-icon {
    font-size: 38px;
    color: var(--app-text);
    z-index: 2;
  }

  .marketplace-empty-logo {
    width: 50px;
    filter: brightness(1) grayscale(1);
    z-index: 2;
  }

  .marketplace-empty-title {
    color: var(--app-text);
    letter-spacing: -0.5px;
  }

  .marketplace-empty-desc {
    max-width: 700px;
    color: var(--app-text-muted);
    line-height: 1.7;
    font-size: 14px;
  }

  .marketplace-connect-btn {
    color: #fff;
    font-weight: 700;
    padding: 14px 28px;
    font-size: 15px;
    box-shadow: 0 12px 30px rgba(244, 91, 104, 0.25);
    transition: all 0.25s ease;
  }

  .marketplace-modal-secondary-btn {
    background: var(--app-surface-alt);
    border-color: var(--app-border);
    color: var(--app-text);
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }

  .marketplace-modal-secondary-btn:hover,
  .marketplace-modal-secondary-btn:focus {
    color: #f45b68;
    border-color: #f45b68;
    background: color-mix(in srgb, #f45b68 10%, var(--app-surface));
  }

  @keyframes marketplaceSpinSlow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  [data-bs-theme="dark"] & .marketplace-empty-state {
    background: linear-gradient(180deg, rgba(244, 91, 104, 0.12) 0%, var(--app-surface) 100%);
  }

  .marketplace-almost-there-banner {
    padding: 16px 18px;
    border-radius: 12px;
    background: color-mix(in srgb, #f45b68 8%, var(--app-surface));
    border: 1px solid color-mix(in srgb, #f45b68 22%, var(--app-border));
  }

  .marketplace-almost-there-title {
    color: var(--app-text);
    font-size: 16px;
    letter-spacing: -0.3px;
  }

  .marketplace-almost-there-action-title,
  .marketplace-empty-action-title {
    color: var(--app-text);
    font-size: 18px;
    letter-spacing: -0.3px;
  }

  .marketplace-empty-action-title {
    margin-top: 0;
  }

  .marketplace-almost-there-divider,
  .marketplace-connect-divider {
    border: 0;
    border-top: 1px dashed var(--app-border);
    opacity: 1;
  }

  .marketplace-connect-divider {
    max-width: 320px;
  }

  .marketplace-almost-there-body {
    color: var(--app-text-muted);
    font-size: 14px;
    line-height: 1.65;
  }

  .marketplace-progress-strip {
    background: var(--app-surface);
    border: 1px solid var(--app-border);
  }

  .marketplace-progress-strip-title {
    color: var(--app-text);
  }

  .marketplace-progress-step {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid var(--app-border);
    background: var(--app-surface-alt);
    color: var(--app-text-muted);
  }

  .marketplace-progress-step.is-done {
    color: #16a34a;
    border-color: color-mix(in srgb, #16a34a 35%, var(--app-border));
    background: color-mix(in srgb, #16a34a 10%, var(--app-surface));
  }

  .marketplace-progress-step.is-pending {
    color: var(--app-text);
    border-color: color-mix(in srgb, #f45b68 30%, var(--app-border));
    background: color-mix(in srgb, #f45b68 6%, var(--app-surface));
  }

  .marketplace-progress-divider {
    width: 24px;
    height: 2px;
    background: var(--app-border);
    border-radius: 2px;
  }
`;